"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoComponent = exports.supportedVideoRegex = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var answers_lib_1 = require("@wix/answers-lib");
exports.supportedVideoRegex = {
    urlYoutube: /https?:\/\/(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube\.com\S*[^\w\-\s])([\w\-]{11})(?=[^\w\-]|$)(?![?=&+%\w.-]*(?:['"][^<>]*>|<\/a>))([?]+(.+))*/ig,
    urlVimeo: /https?:\/\/(www\.)?vimeo.com\/(\d+)([?]+(.+))*/,
    isYoutube: /^(https?\:\/\/)?(www\.youtube\.com|youtu\.?be)\/.+$/,
    isVimeo: /player.vimeo.com\/(.+)*/
};
var urlFix = function (url) {
    var fixedUrl = url;
    if (url) {
        if (url.match(exports.supportedVideoRegex.urlYoutube)) {
            fixedUrl = url.replace(exports.supportedVideoRegex.urlYoutube, '//www.youtube.com/embed/$1' + '?wmode=opaque&enablejsapi=1&' + '$3');
        }
        else if (url.match(exports.supportedVideoRegex.urlVimeo)) {
            fixedUrl = url.replace(exports.supportedVideoRegex.urlVimeo, '//player.vimeo.com/video/$2' + '?api=1&' + '$4');
        }
    }
    return fixedUrl;
};
var VideoComponent = /** @class */ (function (_super) {
    tslib_1.__extends(VideoComponent, _super);
    function VideoComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        return _this;
    }
    VideoComponent.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var videoUrl = urlFix(props.value.url);
        var onRefSet = function (ref) { return _this.iframe = ref; };
        var videoContainerStyle = {
            textAlign: props.value.align || 'center'
        };
        return (React.createElement("div", { className: answers_lib_1.classNames('component video-component', props.direction), "data-component-type": 'video' },
            React.createElement("div", { className: "video-container", style: videoContainerStyle },
                React.createElement("iframe", { src: videoUrl, ref: onRefSet, allowFullScreen: true }))));
    };
    return VideoComponent;
}(React.Component));
exports.VideoComponent = VideoComponent;
//# sourceMappingURL=video-component.comp.js.map